module.exports = __webpack_public_path__ + "img/setup.aee5d5da.jpg";